import {SectionView} from '../ui_canvas_engine/SectionView'
import {PIXI} from '@colonist/pixi'
import {UIGamePlayerAvatarView} from '../ui_game/ui_game_players/UIGamePlayerAvatarView'
import {SpriteView} from '../ui_canvas_engine/SpriteView'
import {UIGameManager} from '../ui_game/UIGameManager'
import {UIGameCardWithRatioContainerView} from '../ui_game/ui_game_card/UIGameCardWithRatioContainerView'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {CardEnum, PlayerColor} from '@colonist/game-states'

export class UIGameTradePlayerArrowInfoView extends SectionView {
    private readonly uiGameManager: UIGameManager
    private avatarLeft: SpriteView | UIGamePlayerAvatarView
    private readonly arrowView: SpriteView
    readonly cardContainer: UIGameCardWithRatioContainerView
    private readonly iconScalarOverride?: number | undefined

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, playerColor: PlayerColor, arrowTexture: PIXI.Texture, cards: CardEnum[], container: PIXI.Container, removeCardPadding: boolean, partitionEnabled: boolean, iconSclarOverride?: number) {
        super(x, y, w, h, container)
        this.uiGameManager = uiGameManager
        this.iconScalarOverride = iconSclarOverride

        this.setLeftAvatar(playerColor)

        const arrowScalar = iconSclarOverride == undefined ? 0.55 : iconSclarOverride
        const arrowSize = this.height * arrowScalar
        const arrowX = this.avatarLeft.x + this.avatarLeft.width * 0.9
        const arrowY = this.height * 0.5 - arrowSize * 0.5
        this.arrowView = new SpriteView(arrowX, arrowY, arrowSize, arrowSize, this, arrowTexture)
        this.arrowView.rotate(-90)

        const cardContainerX = arrowX + arrowSize * 0.7
        const minimumCardContainerWidth = this.height * 1.5
        const cardContainerWidth = Math.max(this.width - cardContainerX, minimumCardContainerWidth)
        this.cardContainer = new UIGameCardWithRatioContainerView(this.uiGameManager, cardContainerX, 0, cardContainerWidth, h, this, true, removeCardPadding, partitionEnabled)
        this.cardContainer.addMultipleCards(cards, false)
        this.cardContainer.cardInventory.cardViews.forEach((cardView) => cardView.view.cursor = 'default')
    }

    private setLeftAvatar(playerColor: PlayerColor) {
        const avatarScalar = this.iconScalarOverride == undefined ? 0.8 : this.iconScalarOverride
        const itemSize = this.height * avatarScalar
        const avatarX = this.uiGameManager.canvasController.margin
        const isAllPlayersIcon = playerColor === PlayerColor.None
        if(isAllPlayersIcon) {
            this.avatarLeft = new SpriteView(avatarX, 0, itemSize, itemSize, this, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_players))
        } else {
            const playerControllerState = this.uiGameManager.gameController.getPlayerState(playerColor)
            this.avatarLeft = new UIGamePlayerAvatarView(avatarX, 0, itemSize, this, playerControllerState)
            this.avatarLeft.centerYInParent()
        }
    }

    async refreshAvatarLeftIcon() {
        if(!(this.avatarLeft instanceof UIGamePlayerAvatarView)) return
        void this.avatarLeft.refreshPlayerIcon()
    }

    resetLeftAvatar(playerColor: PlayerColor) {
        const originalX = this.avatarLeft.x
        const originalY = this.avatarLeft.y
        this.avatarLeft.destroy({children: true})
        this.setLeftAvatar(playerColor)
        this.avatarLeft.x = originalX
        this.avatarLeft.y = originalY
    }

    justifyAvatarsToBottomLeft() {
        const margin = this.height * 0.09
        this.avatarLeft.y = this.height - this.avatarLeft.height - margin
        this.arrowView.y = this.height - this.avatarLeft.height + this.avatarLeft.height / 2 - margin // anchored at 0.5
    }

    justifyAvatarsToTopLeft() {
        const margin = this.height * 0.09
        this.avatarLeft.y = margin
        this.arrowView.y = 0 + this.arrowView.height / 2 + margin // anchored at 0.5
    }

    containsAnyResourceCard(): boolean {
        return this.cardContainer.cardInventory.getAllCardEnums().includes(CardEnum.AnyResource)
    }
}
